import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OAISchema } from '~/types/openapi';

// Response 타입
type CategoryTreeResponse = OAISchema['DisplayCategoryTreeResponse'];

export interface CategoryDataSource {
  getCategoryTree(): Promise<CategoryTreeResponse>;
}

export class CategoryDataSourceImpl implements CategoryDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getCategoryTree() {
    return this.client.request<CategoryTreeResponse>({
      url: '/api/market-place/v1/display-categories',
      method: 'get',
    });
  }
}

export const categoryDataSource = new CategoryDataSourceImpl();
